<template>
  <div>
    <el-tabs v-model="activeProgressNotesTab" @tab-click="handleClick">
        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewAssignments" name="projectTaskProgressAssignments" :label="$t('settings_progress_notes_assignments')">
            <settingTable ref="projectTaskProgressAssignments" />
        </el-tab-pane>
        <el-tab-pane v-if="companyLayout" :disabled="!companyLayout.permission.viewActivities" name="projectTaskProgressActivities" :label="$t('settings_progress_notes_activities')">
            <settingTable ref="projectTaskProgressActivities" />
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import settingTable from '@/components/settings/settingTable'
  let moment = require('moment')
  import axios from 'axios'
  export default {
    components: {
      settingTable,
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        moment: moment,
        activeProgressNotesTab: 'projectTaskProgressAssignments',
      }
    },
    methods: {
      handleClick(tab, event) {
        if(tab.name === 'projectTaskProgressActivities'){
          this.$refs['projectTaskProgressActivities'].loadList(tab.name)
        }else if(tab.name === 'projectTaskProgressAssignments'){
          this.$refs['projectTaskProgressAssignments'].loadList(tab.name)
        }
      },
      loadFirstTab() {
        this.$refs['projectTaskProgressAssignments'].loadList('projectTaskProgressAssignments')
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>